export default "__VITE_ASSET__a6a7e101__"